import { render } from "./CoinTimes.vue?vue&type=template&id=8ad75ebe&scoped=true"
import script from "./CoinTimes.vue?vue&type=script&lang=js"
export * from "./CoinTimes.vue?vue&type=script&lang=js"

import "./CoinTimes.vue?vue&type=style&index=0&id=8ad75ebe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad75ebe"]])

export default __exports__